/* globals moment */
import intl from 'react-intl-universal'

export function _forceTimeHourSetting(format, clockFormat) {
  let formatWithHourSetting = format

  if (clockFormat === '12' && format.includes('H')) {
    formatWithHourSetting = format.replace(/H/g, 'h')
  } else if (clockFormat === '24' && format.includes('h')) {
    formatWithHourSetting = format.replace(/h/g, 'HH').replace(/a/gi, '')
  }

  return formatWithHourSetting
}

export default function() {
  return (input, format = 'MMM D, Y h:mm:ss a', useLocal = false) => {
    const timezone = useLocal ? moment.tz.guess() : window.org_settings.timezone
    // special case timezone text
    if (format === 'TZ_NAME') {
      return timezone.name || 'local'
    }

    if (!input) {
      return ''
    }
    // need date.parse for moment warnings
    const date = moment(Date.parse(input))

    // settings timezone or utc
    const nextDate = timezone ? moment.tz(date, timezone) : moment.utc(date)

    if (nextDate.toString() === 'Invalid date') {
      return input
    } else {
      const { clockFormat } = window.org_settings
      const formatWithHourSetting = _forceTimeHourSetting(format, clockFormat)

      const { currentLocale } = intl.getInitOptions()
      return nextDate.locale(currentLocale).format(formatWithHourSetting)
    }
  }
}
